import {ElasticSearchTreff, EnkelGruppeModell, EntitetType, GruppeId, IndeksertEntitet, OpplastetDokumentVersjonIndeksfelter, SakIndeksfelter} from "../tjenester/ressurser/generertNg2HttpKlient";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";

/** Returnerer {@link EntitetType} avledet av angitt treff */
export function entitetTypeFraTreff(treff: ElasticSearchTreff<any>): EntitetType {
    //benytter oss av det faktum at IndeksertEntitet i typescript definisjonen er et subsett av EntitetType
    return treff._type as any as EntitetType
}

/** Returnerer {@link IndeksertEntitet} knyttet til angitt {@link EntitetType}. */
export function indeksertEntitetFraEntitetType(type: EntitetType): IndeksertEntitet {
    //IndeksertEntitet har entitens klassenavn som verdi, som er det samme som EntitetType benytter
    // @ts-ignore
    return type as IndeksertEntitet;
}

export function treffErAvType(treff: ElasticSearchTreff<any>, type: IndeksertEntitet.sak): treff is ElasticSearchTreff<SakIndeksfelter>
export function treffErAvType(treff: ElasticSearchTreff<any>, type: IndeksertEntitet.opplastetDokumentVersjon): treff is ElasticSearchTreff<OpplastetDokumentVersjonIndeksfelter>
export function treffErAvType(treff: ElasticSearchTreff<any>, type: IndeksertEntitet): treff is ElasticSearchTreff<any>
export function treffErAvType(treff: ElasticSearchTreff<any>, type: IndeksertEntitet): boolean {
    return treff._type === type;
}

export function gruppeFraTreff(treff: ElasticSearchTreffMedGruppeId, kontekst: BrukerkontekstTilbyder): EnkelGruppeModell | null {
    return kontekst.autentisertBruker().finnAutentiserteGruppe(treff._source.gruppe);
}

export type ElasticSearchTreffMedGruppeId = ElasticSearchTreff<{ gruppe: GruppeId }>;
